import { Component, Input } from "@angular/core";
import { CoreSidebar } from "@svs/angular";
import { SidebarBackButtonComponent } from "./sidebar-back-button/sidebar-back-button.component";
import { SidebarHeaderComponent } from "./sidebar-header/sidebar-header.component";
import { SidebarOptionsComponent } from "./sidebar-options/sidebar-options.component";
import { SidebarServicesComponent } from "./sidebar-services/sidebar-services.component";

@Component({
  selector: "app-sidebar",
  imports: [
    SidebarBackButtonComponent,
    SidebarOptionsComponent,
    SidebarServicesComponent,
    SidebarHeaderComponent,
  ],
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.scss",
})
export class SidebarComponent {
  @Input({ required: true }) sidebar!: CoreSidebar;
  @Input({ required: true }) compactView!: boolean;
}
